import { createExperiment } from '@gonfalon/openapi/operations/createExperiment';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { getExperimentsQuery } from '../queries/experiments';

export const useCreateExperiment = createMutationHook(createExperiment, {
  onSuccess: async (_, { projectKey, environmentKey }) => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({
      queryKey: getExperimentsQuery.partialQueryKey({
        projectKey,
        environmentKey,
      }),
    });
  },
});
